export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-4">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm text-gray-600 font-light tracking-wide">
          Powered by{' '}
          <a 
            href="https://www.emerald-system.id" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:text-primary/90 font-medium transition-colors"
          >
            www.emerald-system.id
          </a>
        </p>
      </div>
    </footer>
  );
} 